import Footer from "components/footer/FooterAuthDefault";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoginUser } from "services/users/authSlice";
import Loader from "components/loader";
import Alert from "components/alert";
import InputField from "components/fields/InputField";
import CustomButton from "components/button/custom_button";
import logoImg from "./../../assets/img/home/logo.png";
import { HiChevronLeft } from "react-icons/hi";
import axios from "axios";
import ApiList from "services/apiList";
export default function LibraryAuth() {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    username: "",
    password: "",
  });
  const inputs = [
    {
      id: "signin1",
      name: "username",
      type: "text",
      placeholder: "e.g. manager",
      errorMessage:
        "Хэрэглэгчийн нэр 3-16 тэмдэгтээс бүрдэх бөгөөд ямар нэгэн тусгай тэмдэгт оруулах ёсгүй!",
      label: "Хэрэглэгчийн нэр",
      pattern: "^[A-Za-z0-9]{3,16}$",
      required: true,
    },
    {
      id: "signin2",
      name: "password",
      type: "password",
      placeholder: "Password",
      errorMessage: "Нууц үг 4-10 тэмдэгттэй байх ёстой!",
      label: "Password",
      pattern: "^.{4,10}$",
      required: true,
    },
  ];
  const navigate = useNavigate();

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    if (!e.preventDefault()) {
      setLoading(true);
      try {
        const response = await axios.post(ApiList.libraryLoginUrl, {
          username: values.username,
          password: values.password,
        });
        setLoading(false);
        if (response.status === 200) {
          const secondForm = document.getElementById("koha-login-form");
          if (secondForm) {
            secondForm.submit();
          }
        } else {
          console.error("First form submission failed.");
        }
      } catch (e) {
        setLoading(false);
        console.log("Exception ", e);
      }
    }
  };

  const auth = useSelector((state) => {
    return state.auth;
  });
  return (
    <div className="w-full">
      {" "}
      {loading && <Loader />}
      <button
        onClick={() => navigate(-1)}
        className="absolute left-4 top-4 p-2 "
      >
        <HiChevronLeft className="h-16 w-16 text-white" />
      </button>
      <div className="z-[1] flex h-[100vh] w-full justify-center bg-purple-900 bg-opacity-80 dark:!bg-navy-700">
        <div className="px-4 flex items-center justify-center w-full">
          {" "}
          {/* Add flex and items-center for vertical centering */}
          <div className="rounded-xl bg-white p-2 2xl:p-[5vh] dark:!bg-navy-900 w-full max-w-md lg:max-w-xl">
            {" "}
            <div>
              <div className="flex items-center">
                <a href="/">
                  <img src={logoImg} className="mb-3 h-24 object	" alt="" />
                </a>
                <div className="mx-2 hidden h-14 w-0.5 bg-gray-500 lg:block"></div>
                <p className="font-[800] text-activeOrange">
                  СУРГАЛТЫН <br />
                  МЕНЕЖМЕНТИЙН <br />
                  СИСТЕМ <br />
                </p>
              </div>
            </div>
            {/* Max width for responsiveness */}
            <form onSubmit={handleSubmit}>
              {auth.loading && <Loader />}
              {!auth.loading && auth.error ? <Alert text={auth.error} /> : null}
              {inputs.map((input) => (
                <InputField
                  key={"key" + input.id}
                  id={input.id}
                  {...input}
                  value={values[input.name]}
                  onChange={onChange}
                />
              ))}
              <div className="mb-4"></div>

              <CustomButton text="Нэвтрэх" type="submit" />
            </form>
            <form
              id="koha-login-form"
              action="http://library.edumongolia.mn/cgi-bin/koha/opac-user.pl"
              method="POST"
            >
              {" "}
              <input type="hidden" name="userid" value={values["username"]} />
              <input type="hidden" name="password" value={values["password"]} />
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
